import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      localStorage.setItem("nc_admin_token", res.data.token);
      toast.success("Welcome, admin");
      navigate("/admin");
    } catch { toast.error("Invalid password"); }
    finally { setLoading(false); }
  };

  return (
    <div className="pt-32 pb-20 min-h-[80vh] flex items-center" data-testid="admin-login-page">
      <div className="container-x max-w-md mx-auto">
        <div className="bg-white border border-[#E5DBD8] p-8">
          <div className="w-12 h-12 bg-[#F2E8E4] flex items-center justify-center mx-auto">
            <Lock className="w-5 h-5 text-[#7A1F2B]" strokeWidth={1.5}/>
          </div>
          <h1 className="font-serif text-3xl text-center mt-4 text-[#2D2424]">Admin Login</h1>
          <p className="text-center text-sm text-[#5C5555] mt-2">Sign in to manage your products</p>
          <form onSubmit={submit} className="mt-8">
            <input
              type="password"
              placeholder="Admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full border border-[#E5DBD8] px-4 py-3 focus:outline-none focus:border-[#7A1F2B]"
            />
            <button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-primary w-full mt-4">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
